import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Card, Dropdown, Button } from 'react-bootstrap';
import UttamKalakarFooter from './UttamKalakarFooter';

const AsignAuthorReview = () => {
    const [titlesList, setTitlesList] = useState([]);
    const [selectedArticleId, setSelectedArticleId] = useState('');
    const [authors, setAuthors] = useState([]);
    const [selectedAuthor, setSelectedAuthor] = useState(null);

    useEffect(() => {
        const fetchTitles = async () => {
            try {
                const response = await axios.get(`https://nrdruhs.in/api/manuscriptTitlesAssignR`);
                setTitlesList(response.data.titles);
            } catch (error) {
                console.error('Error fetching titles:', error);
            }
        };

        const fetchAuthors = async () => {
            try {
                const response = await axios.get(`https://nrdruhs.in/api/reviewercategory`);
                setAuthors(response.data.authors);
            } catch (error) {
                console.error('Error fetching authors:', error);
            }
        };

        fetchTitles();
        fetchAuthors();
    }, []);

    const handleAssignAuthor = async () => {
        if (!selectedArticleId || !selectedAuthor) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Please select a title and a reviewer',
            });
            return;
        }

        try {
            console.log("Sending:", {
                articleid: selectedArticleId,
                author: selectedAuthor.name
            });

            // ✅ API CALL
            await axios.put(`https://nrdruhs.in/api/assignAuthorToManuscript`, {
                articleid: selectedArticleId,
                author: selectedAuthor.name
            });

            Swal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Reviewer assigned successfully',
            });

            // ✅ Send Email
            await sendEmailToReviewAuthor();

        } catch (error) {
            console.error('Error assigning reviewer:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to assign reviewer',
            });
        }
    };

    const sendEmailToReviewAuthor = async () => {
        const user = { name: 'Bharat Sankhala' };
        const message = `Hello Reviewer,\n\nAdmin ${user.name} has assigned you an Article to review.\n\nThanks Web Administrator`;

        if (selectedAuthor?.email) {
            try {
                await axios.post('https://nrdruhs.in/sendemailtoreviewauthor', {
                    email: selectedAuthor.email,
                    message: message
                });

                Swal.fire({
                    icon: 'success',
                    title: 'Email Sent',
                    text: 'Reviewer notified successfully',
                });

            } catch (error) {
                console.error('Email error:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Email Failed',
                    text: 'Could not send email',
                });
            }
        }
    };

    return (
        <div>
            <div className="main-content">
                <img
                    src="/assets/NRDRUHSHomeBanner.jpg"
                    alt="Background"
                    className="header-image"
                    style={{ width: '100%', height: '60vh', objectFit: 'cover' }}
                />
            </div>

            <div style={{ marginTop: 90, marginBottom: 90 }}>
                <Card style={{ margin: '0 auto', maxWidth: 600, background: 'linear-gradient(to right, #5433ff, #20bdff, #a5fecb)'  }}>
                    <Card.Body>
                        <h3 style={{ textAlign: 'center' }}>Assign to Reviewer</h3>

                        {/* ✅ TITLE DROPDOWN */}
                        <select
                            className="form-select mb-3"
                            value={selectedArticleId}
                            onChange={(e) => setSelectedArticleId(e.target.value)}
                        >
                            <option value="">Select a title</option>
                            {titlesList.map((t) => (
                                <option key={t.articleid} value={t.articleid}>
                                    {t.title} - {t.articleid}
                                </option>
                            ))}
                        </select>
                    </Card.Body>
                </Card>

                {/* ✅ REVIEWER DROPDOWN */}
                <div style={{ textAlign: 'center', marginTop: 20 }}>
                    <h3>Select Reviewer</h3>
                    <Dropdown>
                        <Dropdown.Toggle>
                            {selectedAuthor
                                ? `${selectedAuthor.name} (${selectedAuthor.category})`
                                : 'Select Reviewer'}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            {authors.map((author) => (
                                <Dropdown.Item
                                    key={author.id}
                                    onClick={() => setSelectedAuthor(author)}
                                >
                                    {author.name} ({author.category})
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>

                {/* ✅ ASSIGN BUTTON */}
                <div className="text-center mt-3">
                    <Button onClick={handleAssignAuthor}>
                        Assign
                    </Button>
                </div>
            </div>

            <UttamKalakarFooter />
        </div>
    );
};

export default AsignAuthorReview;